/**
===================================================
Module: frontend.src.components.visualizer.KeyframeSlider.tsx
Description: Keyframe slider component for timeline navigation in VSLAM visualizer
Owner: Kawada Technosystem Co Ltd
All Rights Reserved
This script is proprietary and confidential.
Unauthorized copying, distribution, or modification of this
file, via any medium, is strictly prohibited.
===================================================
*/

import React from "react";
import { useVisualizer } from "../../contexts/VisualizerContext";

const KeyframeSlider: React.FC = () => {
  const { state, navigateToKeyframe } = useVisualizer();
  const { sessionData, currentKeyframeIndex } = state;

  const handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newIndex = parseInt(event.target.value);
    navigateToKeyframe(newIndex);
  };

  // Don't render if no keyframes
  if (!sessionData?.keyframes || sessionData.keyframes.length === 0) {
    return null;
  }

  return (
    <div id="keyframeSlider" className="keyframe-slider">
      <input
        type="range"
        id="keyframeSliderInput"
        className="keyframe-slider-input"
        min="0"
        max={Math.max(0, sessionData.keyframes.length - 1)}
        value={currentKeyframeIndex}
        onChange={handleSliderChange}
      />
    </div>
  );
};

export default KeyframeSlider;
